import React from 'react';
import { PAYWALL_MODE, STRIPE_PUBLISHABLE_KEY, STRIPE_LINK_MONTHLY } from '../lib/env';
export const DebugOverlay: React.FC = () => {
  const q = new URLSearchParams(window.location.search);
  if (q.get('debug') !== '1') return null;
  const info = {
    url: window.location.href,
    mode: process.env.NODE_ENV || 'production',
    dsN: process.env.REACT_APP_SENTRY_DSN ? 'present' : 'missing',
    boot: (window as any).__BOOT__ || null,
    paywallMode: PAYWALL_MODE,
    stripePkMasked: STRIPE_PUBLISHABLE_KEY ? `${STRIPE_PUBLISHABLE_KEY.slice(0, 8)}…` : 'unset',
    linkMonthlySet: !!STRIPE_LINK_MONTHLY,
  };
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 8,
        left: 8,
        zIndex: 9999,
        background: '#111',
        color: '#fff',
        padding: '8px 12px',
        borderRadius: 8,
        fontFamily: 'ui-monospace',
        fontSize: 12,
        opacity: 0.9,
      }}
    >
      <div>DEBUG</div>
      <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{JSON.stringify(info, null, 2)}</pre>
    </div>
  );
};
